import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {checkoutUnreserveSpot} from '../../actions/checkout';
import {geoJsonDataForSpot, priceInDollars} from '../../utils';
import {onClickDrawerUserReservedSpot} from '../../actions/navOptions';

class UserParkingSpot extends Component {
  constructor(props) {
    super(props);
    this.handleUnreserveClick = this.handleUnreserveClick.bind(this);
  }

  handleUnreserveClick() {
    const { spotIdentifier, isReadOnly, checkoutUnreserveSpot } = this.props;
    if (!isReadOnly) {
      checkoutUnreserveSpot(spotIdentifier);
    }
  }

  render() {
    const {spotIdentifier, isReadOnly} = this.props;
    const spotData = geoJsonDataForSpot(spotIdentifier);
    const {location , size, price} = spotData.properties;
    return (
      <div className="panel panel-spot">
        <div className="panel-body">
          <h5 onClick={() => { this.props.onClickDrawerUserReservedSpot(spotIdentifier); }}>
            <div className="icon-marker-pin pull-left" />
            {spotIdentifier}
          </h5>
          {`${location} ${size}`}
          <br />
          <strong>{priceInDollars(price)}</strong>
          <div className="pull-right">
            <a className={`color-danger hyper-link ${isReadOnly ? 'disabled' : ''}`}
              onClick={this.handleUnreserveClick}>
              <i className="fa fa-trash-o" />&nbsp;Remove
            </a>
          </div>
        </div>
      </div>
    );
  }

}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ checkoutUnreserveSpot, onClickDrawerUserReservedSpot }, dispatch);
};

export default connect(undefined, mapDispatchToProps)(UserParkingSpot);



// WEBPACK FOOTER //
// ./src/containers/UserInfoDrawer/UserParkingSpot.js